export enum NotificationTypeEnum {
    ERROR = "error",
    WARNING = "warning",
    INFO = "info",
    SUCCESS = "success",
}